import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  MatDialog,
  MatDialogClose,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { SupportCloseDialogComponent } from './support-close-dialog/support-close-dialog.component';
import { DgListboxComponent } from 'dg-listbox-lib';

import {
  EmployeeSearch,
  EmployeeSearchData,
} from '../models/employeeSearch.model';
import { DropdownCombo, DropdownData } from '../models/dropdownCombo.model';
import { UserDetail, UserDetailData } from '../models/userDetail.model';
import { DatePipe } from '@angular/common';
import { DgEmployeeSearchComponent } from 'dg-emp-search-lib';
import {
  trigger,
  query,
  transition,
  style,
  animate,
  stagger,
} from '@angular/animations';
import { AsyncDataService } from 'src/app/digigov/services/async-data.service';
import { SupportService } from '../services/support.service';
import { MessageDisplayService } from 'src/app/digigov/services/message-display/message-display.service';
import { AuthenticationService } from 'src/app/digigov/services/authentication.service';
import { DgFileUploadComponent } from 'dg-file-upload-lib';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AppInitService } from 'src/app/digigov/services/app-init.service';
@Component({
  selector: 'app-support-request',
  templateUrl: './support-request.component.html',
  animations: [
    trigger('InOut', [
      transition(':enter', [
        style({
          transform: 'translateY(100%)',
        }),
        animate('0.5s ease-out'),
      ]),
      transition('* => *', [
        style({
          transform: 'translateY(100%)',
        }),
        animate('0.5s ease-out'),
      ]),
      transition(':leave', [
        style({
          transform: 'translateY(-150%)',
        }),
        animate('0.1s ease-out', style({ opacity: 0 })),
      ]),
    ]),
    trigger('StaggerList', [
      transition('* => *', [
        query(
          ':enter',
          [
            style({ opacity: 0 }),
            stagger(5000, [animate('5s', style({ opacity: 1 }))]),
          ],
          { optional: true }
        ),
      ]),
    ]),
  ],
  styleUrls: ['./support-request.component.scss'],
})
export class SupportRequestComponent implements OnInit {
  @ViewChild('listbox') listbox: DgListboxComponent;
  @ViewChild('empSearch') empSearch: DgEmployeeSearchComponent;
  appAcceptedType = ['pdf', 'png', 'docs', 'xlsx', 'csv'];
  //appAttachID: unknown = '130573304';
  appAttachID = '';
  appMaxSize = 5; //5 MB
  appMaxFiles = 5;
  attachmentTitle = 'Attachments';
  attachmentID = '';
  isRefresh = false;
  maxChars = 2000;
  typeList = [];
  subTypeList = [];
  timeList = [];
  noInput = true;
  catList = [];
  priorityList = [];
  //showFieldFlag;
  create = false;
  tooltipPossition = 'left';
  showMinlengthMsg = false;
  supportConfig: FormGroup = new FormGroup({
    desc: new FormControl('', [
      Validators.required,
      Validators.minLength(20),
      Validators.maxLength(2000),
    ]),
    type: new FormControl({ value: null, disabled: true }, [
      Validators.required,
    ]),
    subtype: new FormControl({ value: null, disabled: true }, [
      Validators.required,
    ]),
    time: new FormControl(null),
    selectedRef: new FormControl(null, []),
    cat: new FormControl(null, Validators.required),
    priority: new FormControl(null),
    severity: new FormControl(null),
  });
  detailConfig = new FormGroup({
    toggle: new FormControl('self', Validators.required),
    name: new FormControl<string>(
      { value: null, disabled: true },
      Validators.required
    ),
    department: new FormControl({ value: null, disabled: true }),
    contact: new FormControl(null, [
      Validators.required,
      Validators.pattern('^[0-9]{10}$'),
    ]),
    email: new FormControl(null, [
      Validators.required,
      Validators.pattern('^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\\.[a-z]{2,4}$'),
      Validators.maxLength(60),
    ]),
    desk: new FormControl(null, Validators.pattern(/^[\w\-\ ]+$/)),
  });
  empSearchConfig = {
    multiSelect: false,
    header: 'Name',
    minLengthForSearch: 3,
    minLengthMessage: 'Please enter 3 char',
  };
  orgConfig = {
    prntId: '54',
    fetchPrntOrgOnlyFlag: 'false',
    multiselect: false,
    header: 'Reporting Organization',
    minLengthForSearch: 3,
    minLengthMessage: 'Please enter 3 or more characters',
  };
  selectedEmployees: string;
  refList = [];
  userDtls: UserDetailData;
  empDetails: EmployeeSearchData;
  attchmnt: Event;
  action = false;
  catId: string;
  isSelectable = true;
  columnConfig = [
    {
      columnName: 'Request ID',
      columnId: 'optionValue',
      displayable: true,
    },
    {
      columnName: 'Description',
      columnId: 'desc',
      displayable: true,
    },
    {
      columnName: 'Category',
      columnId: 'cat',
      displayable: true,
    },
    {
      columnName: 'Status',
      columnId: 'status',
      displayable: true,
    },
    {
      columnName: 'Created Date',
      columnId: 'date',
      displayable: true,
    },
  ];
  // typeKeys = {
  //   //value : Combo
  //   '472075': '5000186', //Application
  //   '472076': '5000188', //Hardware
  //   '472077': '5000187', //Network
  // };
  // subTypeKeys = {
  //   //value : Combo

  //   //Application sub-types
  //   '7777700124': '50001861', //AUTHENTICATION
  //   '7777700125': '50001862', //APPLICATION ACCESSIBILITY
  //   '7777700126': '50001863', //MASTERDATA CHANGES
  //   '7777700127': '50001864', //BROWSER ISSUES
  //   '7777700128': '50001865', //MEETING
  //   '7777700129': '50001866', //TRAINING
  //   '7777700130': '50001867', //NEW REQUIREMENT
  //   '7777700131': '50001868', //OTHERS

  //   //Hardware sub-types
  //   '7777700132': '50001881', //OTHERS

  //   //Network sub-types
  //   '7777700133': '50001871', //Network Related Issue
  // };
  @ViewChild('dgFileUpload') dgFileUpload: DgFileUploadComponent;
  content = [];
  @ViewChild('stepper')
  stepper: MatStepper;
  @ViewChild('matAction') matAction: MatDialogClose;
  refDetails: {
    extendedVO?: string;
    customXidBean?: string;
    dbSchema?: string;
    optionValue: string;
    optionText: string;
    optionDesc: string;
    attrValue: string;
    date: string;
    desc: string;
    status: string;
    cat: string;
  }[] = [];
  postId: number;

  //new view
  selectedCat = '';
  animateSelectedCatOnce = false;
  asyncData$: Observable<string>;

  isDiscomEnabledTP: boolean = false;
  attachmentfortp: boolean = false;
  severityList: DropdownData[];
  severityShow = false;
  disableCategories = [];
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      from: string;
      image64?: boolean;
      other?: boolean;
    },
    private dialog: MatDialog,
    private datePipe: DatePipe,
    private asyncDataService: AsyncDataService,
    private supportService: SupportService,
    private messageDisplayService: MessageDisplayService,
    private authService: AuthenticationService,
    public appInitService: AppInitService
  ) {
    if (data.from) {
      this.action = true;
    } else {
      this.action = false;
    }
    if (data.image64) {
      this.asyncData$ = this.asyncDataService.getScreenshotString().pipe(
        tap((imageString: string) => {
          if (imageString) {
            this.uploadScreenShot(imageString);
            this.asyncDataService.setScreenshotString(null);
          }
        })
      );
    }
  }
  onlyApplication = false;
  ngOnInit(): void {
    this.appInitService?.getConfigurableFields()?.subscribe(() => {
      this.onlyApplication = this.appInitService?.appConfig?.configurableFields?.SUPPORT_REQUEST_ONLY_APPLICATION_SELECTED;
      this.disableCategories = this.appInitService?.appConfig?.configurableFields?.SUPPORT_REQUEST_DISABLE_CATEGORIES?.split(
        ','
      );
      this.supportService
        .getComboItems(5000189)
        .subscribe((res: DropdownCombo) => {
          this.catList = res['data'];
          this.disableCategories.forEach((element) => {
            this.catList = this.catList.filter(
              (item) => item?.optionValue !== element
            );
          });

          if (this.disableCategories?.length == 2) {
            if (!this.disableCategories?.includes('472075')) {
              this.showField('472075');
              this.applicationClick();
              //   this.showFieldFlag = 1;
              const index = this.catList.findIndex(
                (x: DropdownData) => x.optionValue == '472075'
              );
              this.supportConfig.controls['cat'].setValue(this.catList[index]);
              this.populateRequestType(
                this.supportConfig.controls['cat'].value.attrValue
              );
            } else if (!this.disableCategories?.includes('472076')) {
              this.showField('472076');
              this.hardwareClick();
              //  this.showFieldFlag = 2;
              const index = this.catList.findIndex(
                (x: DropdownData) => x.optionValue == '472076'
              );
              this.supportConfig.controls['cat'].setValue(this.catList[index]);
              this.populateRequestType(
                this.supportConfig.controls['cat'].value.attrValue
              );
            } else if (!this.disableCategories?.includes('472077')) {
              this.showField('472077');
              this.networkClick();
              //   this.showFieldFlag = 3;
              const index = this.catList.findIndex(
                (x: DropdownData) => x.optionValue == '472077'
              );
              this.supportConfig.controls['cat'].setValue(this.catList[index]);
              this.populateRequestType(
                this.supportConfig.controls['cat'].value.attrValue
              );
            }
          }
        });

      this.severityShow = this.appInitService?.appConfig?.configurableFields?.SUPPORT_REQUEST_SEVERITY_SHOW;

      this.isDiscomEnabledTP = this.appInitService?.appConfig?.configurableFields?.isDiscomEnabledTP;
      // if (this.isDiscomEnabledTP) {
      //   //FUNCTIONAL ISSUES
      //   this.subTypeKeys['7777700416'] = '5006001892';
      // }
      if (this.data.other) {
        this.detailConfig.controls['toggle'].setValue('other');
      }

      this.supportConfig.controls['cat'].valueChanges.subscribe(
        (value: DropdownData) => {
          if (value) {
            this.supportConfig.controls['type'].reset();
            this.supportConfig.controls['subtype'].reset();
            this.populateRequestType(value.attrValue);
          } else {
            this.typeList = [];
            this.subTypeList = [];
            this.supportConfig.controls['type'].reset();
            this.supportConfig.controls['subtype'].reset();
            this.supportConfig.controls['type'].disable();
            this.supportConfig.controls['subtype'].disable();
          }
        }
      );
      this.supportService
        .getComboItems(500025)
        .subscribe((res: DropdownCombo) => {
          this.priorityList = res?.['data'];
        });
      this.supportService
        .getComboItems(2060)
        .subscribe((res: DropdownCombo) => {
          this.severityList = res?.['data'];
        });
      this.supportService
        .getComboItems(500024)
        .subscribe((res: DropdownCombo) => {
          this.timeList = res?.['data'];
        });
      this.userDtls = this.supportService.loggedInUserDetails;
      if (!this.data.other) {
        this.detailConfig.controls['name'].setValue(this.userDtls.empFullName);
        this.detailConfig.controls['department'].setValue(
          this.userDtls?.unitVO?.[0]?.organizationVOArr?.[
            this.userDtls?.unitVO?.[0]?.organizationVOArr.length - 1
          ]?.organizationName
        );
        this.detailConfig.controls['contact'].setValue(
          this.userDtls.mobileNo
            ? this.userDtls.mobileNo
            : this.userDtls.phoneNumber
        );
        this.detailConfig.controls['email'].setValue(
          this.userDtls.empEmailID?.toLowerCase()
        );
      }

      if (this.data.other) {
        this.content = [];
      } else {
        this.authService.loggedInUserPost$.subscribe((postData) => {
          if (typeof postData === 'string' && postData) {
            let skip = false;
            this.authService.loggedInUser.employeeVO.allUnitVO.forEach(
              (unit) => {
                if (!skip) {
                  this.postId = unit?.postId;
                  skip = true;
                }
              }
            );
          } else {
            this.postId = postData?.POST_ID;
          }
          this.populatePrevRef(this.postId);
        });
      }
      this.detailConfig.controls['toggle'].valueChanges.subscribe(
        (value: string) => {
          if (value === 'self') {
            this.detailConfig.controls['name'].setValue(
              this.userDtls.empFullName
            );
            this.detailConfig.controls['department'].setValue(
              this.userDtls?.unitVO?.[0]?.organizationVOArr?.[
                this.userDtls?.unitVO?.[0]?.organizationVOArr.length - 1
              ]?.organizationName
            );
            this.detailConfig.controls['contact'].setValue(
              this.userDtls.mobileNo
                ? this.userDtls.mobileNo
                : this.userDtls.phoneNumber
            );
            this.detailConfig.controls['email'].setValue(
              this.userDtls?.empEmailID?.toLowerCase()
            );
            this.detailConfig.controls['desk'].setValue('');
          }
          if (value === 'other') {
            this.detailConfig.markAsUntouched();
            this.detailConfig.controls['department'].setValue('');
            this.detailConfig.controls['contact'].setValue('');
            this.detailConfig.controls['email'].setValue('');
            this.detailConfig.controls['desk'].setValue('');
          }
        }
      );
    });
  }
  onFinalPath(finalPath: Event): void {
    this.attchmnt = finalPath;
    if (this.attchmnt) {
      this.noInput = false;
    } else {
      this.noInput = true;
    }
  }
  populatePrevRef(id: number): void {
    this.supportService
      .getComboItems(95009, id)
      .subscribe((res: DropdownCombo) => {
        let data = [];
        data = res['data'];
        this.refList = data;
        for (const x of data) {
          let a = [];
          a = x.optionText.toString().split(' ~ ');
          x['date'] = this.datePipe.transform(
            new Date(a[1]).toLocaleString(),
            'MMM d, y, HH:mm:ss'
          );
          x['desc'] = a[2];
          x['status'] = a[3];
          x['cat'] = a[4];
        }
        this.content = data;
      });
  }
  showField(catId: string): void {
    // this.showFieldFlag = value;
    const index = this.catList.findIndex(
      (x: DropdownData) => x.optionValue === catId
    );
    this.supportConfig.controls['cat'].setValue(this.catList[index]);
  }
  populateRequestType(id: string): void {
    this.supportConfig.controls['type'].disable();
    this.supportService.getComboItems(id).subscribe((res: DropdownCombo) => {
      const restemp = res;
      this.typeList = restemp?.data;
      if (this.typeList) {
        this.supportConfig.controls['type'].enable();
      } else {
        this.supportConfig.controls['type'].disable();
      }
    });
    this.supportConfig.controls['type'].valueChanges.subscribe(
      (value: DropdownData) => {
        if (value) {
          this.supportConfig.controls['subtype'].reset();
          this.populateSubType(value.attrValue);
        } else {
          this.subTypeList = [];
          this.supportConfig.controls['subtype'].reset();
          this.supportConfig.controls['subtype'].disable();
        }
      }
    );
  }
  populateSubType(id: string): void {
    this.subTypeList = [];
    this.supportConfig.controls['subtype'].setValue(null);
    this.supportConfig.controls['subtype'].disable();
    this.supportService.getComboItems(id).subscribe((res: DropdownCombo) => {
      const restemp = res;
      this.subTypeList = restemp?.data;
      if (this.subTypeList) {
        this.supportConfig.controls['subtype'].enable();
      } else {
        this.supportConfig.controls['subtype'].disable();
      }
    });
  }
  getEmpData(val: EmployeeSearchData[] | EmployeeSearchData): void {
    this.empDetails = Array.isArray(val) ? val?.[0] : val;
    if (this.empDetails) {
      if (this.userDtls.empId === this.empDetails.EMP_ID) {
        this.empSearch.reset();
        const errorMsg = {
          errors: [
            {
              message: 'You cannot raise request for yourself',
            },
          ],
        };
        this.messageDisplayService.errorToast(errorMsg);
        this.detailConfig.controls['name'].setValue(null);
        this.detailConfig.controls['department'].setValue(null);
        this.detailConfig.controls['contact'].setValue(null);
        this.detailConfig.controls['email'].setValue(null);
      } else {
        this.detailConfig.controls['name'].setValue(this.empDetails.FULL_NAME);
        this.detailConfig.controls['department'].setValue(
          this.empDetails.ORG_NAME
        );
        this.supportService
          .getEmployeeSearchDetails(this.empDetails.EMP_ID)
          .subscribe((res: UserDetail) => {
            const restemp = res.data;
            this.detailConfig.controls['contact'].setValue(
              restemp.mobileNo ? restemp.mobileNo : restemp.phoneNumber
            );
            this.detailConfig.controls['email'].setValue(
              restemp.empEmailID?.toLowerCase()
            );
          });
      }
    } else {
      this.detailConfig.controls['name'].setValue(null);
      this.detailConfig.controls['department'].setValue(null);
      this.detailConfig.controls['contact'].setValue(null);
      this.detailConfig.controls['email'].setValue(null);
    }
  }
  onDescClick(): void {
    if (this.supportConfig.controls['desc'].value.length < 20) {
      this.showMinlengthMsg = true;
    } else {
      this.showMinlengthMsg = false;
    }
    this.supportConfig.controls['desc'].valueChanges.subscribe(
      (value: string) => {
        if (value) {
          if (value.length < 20) {
            this.showMinlengthMsg = true;
          } else {
            this.showMinlengthMsg = false;
          }
        }
      }
    );
  }
  onBlurDesc(): void {
    this.supportConfig.controls['desc'].setValue(
      this.supportConfig.controls['desc'].value.trim(),
      {
        emitEvent: false,
      }
    );
  }
  onDeskBlur(): void {
    this.detailConfig.controls['desk'].setValue(
      this.detailConfig?.controls['desk']?.value?.trim(),
      {
        emitEvent: false,
      }
    );
  }
  onSubmit(): void {
    this.create = true;
    let empId: number;
    const user = this.detailConfig?.controls['name']?.value;
    let deptId;
    //USING THIS BCS NOT GETTING DEPTID IN EMP SEARCH
    deptId = this.userDtls?.unitVO?.[0]?.organizationVOArr?.[
      this.userDtls?.unitVO?.[0]?.organizationVOArr.length - 1
    ]?.organizationId;
    if (this.detailConfig.controls['toggle'].value == 'self') {
      empId = this.userDtls.empId;

      // deptId = this.userDtls.departmentVO[0].deptId;
    } else {
      empId = this.empDetails.EMP_ID;

      //deptId = this.empDetails?.UNIT_ID;
    }
    let forPrev = '';
    let prevList: string;
    if (
      this.refDetails.length > 0 &&
      this.detailConfig.controls['toggle'].value === 'self'
    ) {
      const values = this.refDetails;
      for (let i = 0; i < values?.length; i++) {
        if (i === 0) {
          const addFirstCombo = values[i].optionValue;
          prevList = addFirstCombo;
        } else {
          const sc = values[i].optionValue;
          const addCombo = ',' + sc;
          prevList = prevList + addCombo;
        }
      }
    }
    if (prevList?.length > 0) {
      forPrev = prevList;
    }
    // let postId;
    // this.authService.loggedInUserPost$.subscribe((postData) => {
    //   if (typeof postData === 'string' && postData) {
    //     let skip = false;
    //     this.authService.loggedInUser.employeeVO.allUnitVO.forEach((unit) => {
    //       if (!skip) {
    //         postId = unit?.postId;
    //         skip = true;
    //       }
    //     });
    //   } else {
    //     postId = postData?.POST_ID;
    //   }
    // });
    const postObj = {
      department: deptId,
      reqCat: parseInt(this.supportConfig.controls['cat'].value.optionValue),
      reqType: this.supportConfig.controls['type'].value
        ? parseInt(this.supportConfig.controls['type'].value.optionValue)
        : null,
      reqsubType: this.supportConfig.controls['subtype'].value
        ? parseInt(this.supportConfig.controls['subtype'].value.optionValue)
        : null,
      byEmpId: empId, // Raised Emp Id
      agentResolutionDtlVOs: [
        {
          priority: this.supportConfig.controls['priority'].value
            ? parseInt(
                this.supportConfig.controls['priority'].value.optionValue
              )
            : null,
          severity: this.supportConfig.controls['severity'].value
            ? parseInt(
                this.supportConfig.controls['severity'].value.optionValue
              )
            : null,
        },
      ],
      prefCallTime: this.supportConfig.controls['time'].value
        ? parseInt(this.supportConfig.controls['time'].value.optionValue)
        : null,
      //byPostId: 3001409, //for raised
      contactNo: this.detailConfig.controls['contact'].value.toString(),
      emailId: this.detailConfig.controls['email'].value,
      deskArea: this.detailConfig.controls['desk'].value,
      srDesc: this.supportConfig.controls['desc'].value.trim(),
      attachString: this.attchmnt.toString(),
      //crtPost: 3001409, // for

      onBehalfId: this.postId,
      //Number(postId), // Logged In user PostId
      //revSRNum: forPrev,
      prevSRNum: forPrev,
      portal_userName: user,
      portal_userId: this.userDtls.empId,
      portal: true,
    };
    this.supportService.raiseTicket(postObj).subscribe(
      () => {
        this.reset();
      },
      (error) => {
        console.error(error);
        this.create = false;
      }
    );
  }
  reset(): void {
    this.supportConfig.reset();
    this.detailConfig.reset();
    this.detailConfig.controls['toggle'].setValue('self');
    this.isRefresh = true;
    this.stepper.reset();
    this.refDetails = [];
    this.dialog.closeAll();
  }
  // DG List Data

  dgListData(value: []): void {
    this.refDetails = value;
    if (this.refDetails.length > 5) {
      setTimeout(() => {
        const deselect = value.pop();

        this.listbox.selectedRows = {
          uniqueKeyName: 'optionValue',
          selectedRowList: value,
        };
        this.refDetails = value;
      }, 10);
      const errorMsg = {
        errors: [
          {
            message: 'Max selection limit : 5',
          },
        ],
      };
      this.messageDisplayService.errorToast(errorMsg);
    }
  }
  //stepper
  onClose(): void {
    const dialogRef = this.dialog.open(SupportCloseDialogComponent, {
      width: 'auto',
      height: 'auto',
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.dialog.closeAll();
      }
    });
  }
  onNext(): void {
    if (this.stepper.selectedIndex < 2) {
      this.stepper.selectedIndex = this.stepper.selectedIndex + 1;
    }
  }
  onPrev(): void {
    if (this.stepper.selectedIndex > 0) {
      this.stepper.selectedIndex = this.stepper.selectedIndex - 1;
    }
  }
  //base64 to Image
  DataURIToBlob(dataURI: string): Blob {
    const splitDataURI = dataURI.split(',');
    const byteString =
      splitDataURI[0].indexOf('base64') >= 0
        ? atob(splitDataURI[1])
        : decodeURI(splitDataURI[1]);
    const mimeString = splitDataURI[0].split(':')[1].split(';')[0];

    const ia = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++)
      ia[i] = byteString.charCodeAt(i);
    return new Blob([ia], { type: mimeString });
  }
  uploadScreenShot(value: string): void {
    const formData: FormData = new FormData();
    const dataFile = new File(
      [this.DataURIToBlob(value)],
      'auto-captured-screenshot.png',
      {
        type: 'image/png',
      }
    );
    this.attachmentfortp = this.appInitService?.appConfig?.configurableFields?.attachmentForTP;
    if (this.attachmentfortp == false) {
      this.dgFileUpload.uploadFile([dataFile]);
    }
  }

  //new view

  applicationClick(): void {
    this.selectedCat = '472075';
    this.animateSelectedCatOnce = true;
    this.catList.forEach((unit) => {
      if (unit.optionValue == this.selectedCat)
        this.populateRequestType(unit.attrValue);
    });
  }
  hardwareClick(): void {
    this.selectedCat = '472076';
    this.animateSelectedCatOnce = true;
    this.catList.forEach((unit) => {
      if (unit.optionValue == this.selectedCat)
        this.populateRequestType(unit.attrValue);
    });
  }
  networkClick(): void {
    this.selectedCat = '472077';
    this.animateSelectedCatOnce = true;
    this.catList.forEach((unit) => {
      if (unit.optionValue == this.selectedCat)
        this.populateRequestType(unit.attrValue);
    });
  }
}
